import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sSubLotLPGainControllerEndpoint = 'SubLotCreationGainL2';


export class UsedRentalsSubLotLPGainAPI {
  params;

  getSubLotLPGainByL2Id(ruL2Id) {
    return axios.get(getBackendURL() + sSubLotLPGainControllerEndpoint + '/GetRUL2LPGainListByL2Id?ruL2Id=' + ruL2Id);
  }

  saveNewSubLotLPGain(subLotLPGainDTO) {
    return axios.post(getBackendURL() + sSubLotLPGainControllerEndpoint + '/CreateRUL2LPGain', subLotLPGainDTO);
  }

  saveEditSubLotLPGain(subLotLPGainDTO) {
    return axios.put(getBackendURL() + sSubLotLPGainControllerEndpoint + '/EditRUL2LPGain', subLotLPGainDTO);
  }

  deleteSubLotLPGain(subLotId, gainId) {
    this.params = {
      subLotId: subLotId,
      gainId: gainId,
    }
    return axios.delete(getBackendURL() + sSubLotLPGainControllerEndpoint + '/DeleteRUL2LPGain', { params: this.params });
  }

}

export default UsedRentalsSubLotLPGainAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsSubLotLPGainAPI.js